import { render, staticRenderFns } from "./PrivilegeSubCategory.vue?vue&type=template&id=32e1f35b&scoped=true&"
import script from "./PrivilegeSubCategory.vue?vue&type=script&lang=js&"
export * from "./PrivilegeSubCategory.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeSubCategory.vue?vue&type=style&index=0&id=32e1f35b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e1f35b",
  null
  
)

export default component.exports